import { axiosInstance } from "./AxiosInstance";

export async function getAdvanceDirectives(patientId) {
  return axiosInstance
    .get(`api/PatientAdvnDirectives?patientId=${patientId}`)
    .then(function (response) {
      //debugger;
      return response;
    })
    .catch(function (error) {
      return error;
    });
}
